/**
 * Legal facts the Owner still has to supply. Single place to fill in (Privacy Policy + Terms of Use
 * both read from here). Replace each placeholder string with the real value, e.g.
 *   export const EFFECTIVE_DATE = "October 15, 2026";
 *
 * Filled 2026-10-10 (CLO): EFFECTIVE_DATE = the publish date (update it if go-live slips); MESSAGE_RETENTION_PERIOD =
 * 2 years (DTPA limitations period, Tex. Bus. & Com. Code 17.565, plus margin; data-minimizing); VENUE_COUNTY = Harris
 * (Owner's mailbox county; terms text appends " County"). Venue must follow the company's real principal/registered office.
 *
 * Mailing address: published ONLY as one small line in the Privacy Policy Contact section and in email footers
 * (CAN-SPAM, 15 U.S.C. 7704(a)(5)). Not on site pages, forms, or the footer. Not a LEGAL_FACTS_READY blocker.
 *
 * Guard: src/__tests__/legalConfig.test.js fails when any value is still a placeholder and
 * REACT_APP_REQUIRE_LEGAL_FACTS=true (set that in the production build/CI environment).
 */
export const EFFECTIVE_DATE = "October 10, 2026";
export const MESSAGE_RETENTION_PERIOD = "2 years";
export const VENUE_COUNTY = "Harris";

/** Private mailbox (CMRA). Confirm the CMRA's own required format and that USPS Form 1583 is on file before first send. */
export const MAILING_ADDRESS = "2162 Spring Stuebner Rd, Ste 140 PMB 131, Spring, TX 77389";
/** For the footer of every commercial email (and the confirmation email). Not rendered on any site page. */
export const MAILING_ADDRESS_EMAIL_FOOTER = `RateCurrent LLC, ${MAILING_ADDRESS}`;

/** A value is an unfilled placeholder when empty or still a bracketed TODO string. */
export const isPlaceholder = (value) => !value || /^\s*\[[^\]]*\]\s*$/.test(value);

export const LEGAL_FACTS = { EFFECTIVE_DATE, MESSAGE_RETENTION_PERIOD, VENUE_COUNTY };

/**
 * True only when ALL three facts above are filled in. While false, the site shows the Privacy Policy and
 * Terms of Use as "coming soon" (footer labels, a noindexed notice on /privacy and /terms, no sitemap entry,
 * no placeholder text anywhere). filling in the three values flips everything on with no other code change.
 * scripts/legal-facts.js computes the same answer for the sitemap and the prerender (Node, no ES modules).
 */
export const computeLegalFactsReady = (facts) => Object.values(facts).every((v) => !isPlaceholder(v));
export const LEGAL_FACTS_READY = computeLegalFactsReady(LEGAL_FACTS);
